import type { MouseBar } from './mouse-bar'
import type { MouseTimeDisplay } from './mouse-time-display'

import { Events } from '|>/shared/events'
import { findPosition, getPointerPosition } from '|>/shared/h'
import { on, register } from '|>/shared/vjs'
import { BaseProgressControl } from '../base'
import { VodSeekBar } from './vod-seek-bar'

import './vod-progress-control.css'

/**
 * VOD progress bar control
 * https://github.com/videojs/video.js/blob/e78bcc7b2d829fce01451cf105b918d8feec4548/src/js/control-bar/progress-control/progress-control.js
 */
@register
export class VODProgressControl extends BaseProgressControl {
  declare seekBar: VodSeekBar
  declare mouseTimeDisplay: MouseTimeDisplay

  constructor(player, options) {
    super(player, options)
  }

  @on('touchstart')
  handleTouchMove() {
    this.seekBar.mouseTimeDisplay?.show()
  }

  @on('touchend')
  handleTouchEnd() {
    this.seekBar.mouseTimeDisplay?.hide()
  }

  @on('ended')
  checkProgramProgress() {
    this.player_.trigger(Events.Player.ProgressReachedEnd)
  }

  override handleMouseMove(event) {
    super.handleMouseMove(event)

    const seekBar = this.getChild('seekBar')
    const mouseBar = seekBar?.getChild('mouseBar') as MouseBar
    const mouseTimeDisplay = seekBar?.getChild(
      'mouseTimeDisplay'
    ) as unknown as MouseTimeDisplay

    if (!seekBar || !mouseBar || !mouseTimeDisplay) return

    const el = seekBar.el()
    const rect = findPosition(el)
    const point = getPointerPosition(el, event).x

    const pointPx = point * rect.width
    mouseTimeDisplay.updateTooltip(
      rect,
      point,
      pointPx,
      0,
      this.player_.duration() * 1000
    )

    mouseBar.update(rect, point)
  }
}

VODProgressControl.options = {
  className: 'vjs-x-vod-progress-control',
  children: [VodSeekBar.as('seekBar')],
}
